<template>
  <div class="container-fluid pt-4">
    <iframe src="//lightwidget.com/widgets/388e840048fa54a0987bfa8c600d8f71.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe>
  </div>
</template>

<script>
export default {
  name: 'PortfolioPage'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PortfolioPage.vue